import React, {FunctionComponent, PropsWithChildren} from "react";

import {styled} from "@reside/ui";
import {Text} from "@reside/ui";

export const MenuItemContainer = styled.div`
  margin-top: 15px;
  padding-inline: 15px;

  cursor: pointer;

  a {
    display: block;
  }

  &:hover {
    opacity: 0.5;
  }
`;

export const MenuItem: FunctionComponent<
  PropsWithChildren<{
    active?: boolean;
    className?: string;
    Container?: FunctionComponent;
  }>
> = ({active, className, Container = MenuItemContainer, children}) => (
  <Container>
    <Text
      className={className}
      fontWeight={active ? "bold" : "normal"}
      lineHeight="18px"
      color={active ? "primary" : "darkBlue100"}
    >
      {children}
    </Text>
  </Container>
);
